<template lang="pug">
  .container_confirma_ponto
    .container_confirma_ponto__corpo
      .columns.is-vcentered.is-mobile.outline(
        tabindex="-1"
        v-focus
        @keyup.enter="finalizarSessaoDaMarcacao"
      )
        .container.column.p0
          h1.has-text-centered {{ $t('componentes.marcacao.views.confirmacaoPonto.titulo') }}
          br(aria-hidden="true")
          .columns.is-centered.has-text-centered
            img(:src="require('../../../../static/images/confirmacao.svg')" alt="símbolo de confirmação em verde")
          br(aria-hidden="true")
          h2.has-text-centered.texto-registro.bold  {{ infoPonto.momentoDaJornada }}
          .columns.is-centered(v-if="!erroBuscarDadosDaMarcacao")
            .column.is-three-quarters.has-text-centered
              span.texto-registro {{ $t('componentes.marcacao.views.confirmacaoPonto.labelRegistroFeito') }}:
              span.texto-registro.bold {{infoPonto.horarioDaMarcacao}}
          br(aria-hidden="true")
          .columns.is-centered
            .column.is-three-quarters
              .identificacao-wrapper
                .identificacao
                  .titulo {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregado.label') }}:
                  p.nome(v-if="infoPonto.nomeEmpregado") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregado.labelNome') }}:
                    span {{infoPonto.nomeEmpregado}}
                  p(v-if="infoPonto.cpfEmpregado") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregado.labelCPF') }}:
                    span {{formatarCPF(infoPonto.cpfEmpregado)}}
                  p(v-if="jornadaDoDia") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregado.labelJornada') }}:
                    span {{jornadaDoDia}}
                .identificacao
                  .titulo {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.label') }}:
                  p(v-if="infoPonto.razaoSocialEmpregador") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelRazaoSocial') }}:
                    span {{infoPonto.razaoSocialEmpregador}}
                  p(v-if="infoPonto.cpfEmpregador") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelCPF') }}:
                    span {{formatarCPF(infoPonto.cpfEmpregador)}}
                  p(v-if="infoPonto.cnpjEmpregador") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelCNPJ') }}:
                    span {{formatarCNPJ(infoPonto.cnpjEmpregador)}}
                  p(v-if="infoPonto.cnoEmpregador") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelCNO') }}:
                    span {{formatarCNO(infoPonto.cnoEmpregador)}}
                  p(v-if="infoPonto.endereco") {{ $t('componentes.marcacao.views.baseComum.identificacaoEmpregador.labelEndereco') }}:
                    span {{infoPonto.endereco}}
          .columns.is-centered.aviso-infos-extras(v-if="erroNoEnvioInfosExtras || erroBuscarDadosDaMarcacao ")
            .icone-chapado-alerta
            span(v-if="erroNoEnvioInfosExtras") {{ $t('componentes.marcacao.views.confirmacaoPonto.erroEnvioInfosExtras') }}
            span(v-else-if="erroBuscarDadosDaMarcacao") {{ $t('componentes.marcacao.views.confirmacaoPonto.erroBuscarDadosDaMarcacao') }}
          .columns.is-centered(v-if="!erroBuscarDadosDaMarcacao")
            .column.is-three-quarters.is-flex
              .column.is-half(style="padding-left: 0px")
                Button3d(color="info" size="medium" :block="true" @click="baixarComprovante(marcacaoId)" ref="download") {{ $t('componentes.marcacao.views.confirmacaoPonto.botaoBaixarComprovante') }}
              .column.is-half(style="padding-right: 0px")
                Button3d(color="success" size="medium" :block="true" @click="finalizarSessaoDaMarcacao") {{ $t('componentes.marcacao.views.confirmacaoPonto.botaoFinalizar') }}
          .columns.is-centered(v-else)
            .column.is-three-quarters.is-flex
                Button3d(color="success" size="medium" :block="true" @click="finalizarSessaoDaMarcacao") {{ $t('componentes.marcacao.views.confirmacaoPonto.botaoFinalizar') }}
    UrlDeRedirecionamento()

</template>

<script>
import moment from 'moment'
import { removerTimezoneOffSet } from '../../../utils'
import { formatarMomentoDaJornada } from '../utils'
import UrlDeRedirecionamento from '../../Sincronizador/Components/UrlsDeRedirecionamento.vue'

export default {
  name: 'ConfirmacaoPonto',
  components: {
    UrlDeRedirecionamento
  },
  data () {
    return {
      marcacaoId: null,
      temporizadorRedirecionamentoPin: null
    }
  },
  mounted () {
    const marcacaoId = this.$store.state.marcacao.marcacaoId
    const ehColetorSSO = this.$store.getters['ehColetorSSO']
    this.$store.commit('marcacao/atribuiProcessandoPonto', false)
    if (!marcacaoId) {
      this.$router.push({ name: 'sincronizador' })
    }
    this.marcacaoId = marcacaoId

    if (!ehColetorSSO) {
      this.iniciarTemporizadorDeRedirecionamentoParaPin()
    }
  },
  beforeDestroy () {
    if (this.temporizadorRedirecionamentoPin) {
      clearInterval(this.temporizadorRedirecionamentoPin)
    }
  },
  computed: {
    infoPonto () {
      const comprovante = this.$store.state.marcacao.comprovanteMarcacao
      if (comprovante) {
        const { empregado, empregador, horarioDaMarcacao, local } = comprovante
        const momentoDaJornada = this.$store.state.marcacao.momentoDaJornada
        const horario = moment.utc(removerTimezoneOffSet(horarioDaMarcacao))

        return {
          nomeEmpregado: empregado.nome || false,
          cpfEmpregado: empregado.cpf || false,
          razaoSocialEmpregador: empregador.razaoSocial || false,
          cpfEmpregador: empregador.cpf || false,
          cnpjEmpregador: empregador.cnpj || false,
          cnoEmpregador: empregador.cno || false,
          endereco: local.endereco || false,
          horarioDaMarcacao: `${moment(horario).format('DD/MM/YY')} ${this.$t(
            'componentes.marcacao.views.confirmacaoPonto.infoPonto.pontoAs'
          )} ${moment(horario).format('HH:mm:ss')}`,
          momentoDaJornada: `${this.$t(
            'componentes.marcacao.views.confirmacaoPonto.infoPonto.pontoDe'
          )} ${formatarMomentoDaJornada(momentoDaJornada)}`
        }
      }
      const { nome, cpf, empregador } = this.$store.getters['sincronizador/empregadoSincronizado']
      const momentoDaJornada = this.$store.state.marcacao.momentoDaJornada
      const local = this.$store.state.marcacao.localDeTrabalhoMarcacao
      return {
        nomeEmpregado: nome || false,
        cpfEmpregado: cpf || false,
        razaoSocialEmpregador: empregador.razaoSocial || false,
        cpfEmpregador: empregador.cpf || false,
        cnpjEmpregador: empregador.cnpj || false,
        endereco: local.endereco || false,
        momentoDaJornada: `${this.$t(
          'componentes.marcacao.views.confirmacaoPonto.infoPonto.pontoDe'
        )} ${formatarMomentoDaJornada(momentoDaJornada)}`
      }
    },
    jornadaDoDia () {
      const jornada = this.$store.getters['sincronizador/jornadaDoDia']

      if (!jornada) return false

      if (jornada.tipo === 'folga') return jornada.nome

      return `${jornada.inicio} - ${jornada.fim} ${jornada.duracaoPausa ? `| ${jornada.duracaoPausa}` : ''}`
    },
    erroNoEnvioInfosExtras () {
      return this.$store.state.marcacao.erroEnvioInfosExtras
    },
    erroBuscarDadosDaMarcacao () {
      return this.$store.state.marcacao.erroBuscarDados
    }
  },
  methods: {
    formatarCPF (cpf) {
      cpf = cpf.replace(/[^\d]/g, '')
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },
    formatarCNPJ (cnpj) {
      cnpj = cnpj.replace(/[^\d]/g, '')
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    },
    formatarCNO (cno) {
      cno = cno.replace(/[^\d]/g, '')
      return cno.replace(/(\d{2})(\d{3})(\d{5})(\d{2})/, '$1.$2.$3/$4')
    },
    async baixarComprovante (id) {
      await this.$store.dispatch('marcacao/buscarComprovanteMarcacaoPdf', {id})
    },
    finalizarSessaoDaMarcacao () {
      const ehColetorSSO = this.$store.getters['ehColetorSSO']
      if (ehColetorSSO) {
        this.$store.commit('sincronizador/resetState')
        this.$store.dispatch('sincronizador/fazerSincronizacaoWebSSO', {})
        return
      }
      this.$router.push({ name: 'sincronizador' })
    },
    iniciarTemporizadorDeRedirecionamentoParaPin () {
      this.temporizadorRedirecionamentoPin = setTimeout(() => {
        this.$router.push({name: 'sincronizador'})
      }, 360000)
    }
  }
}
</script>
<style scoped>
.container_confirma_ponto{
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}

.container_confirma_ponto__corpo{
    margin-top: 10px;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.container_confirma_ponto__corpo:only-child {
  height: auto;
  margin-top: 0;
}

.outline {
  outline: none;
}
.identificacao-wrapper {
  width: 100%;
  display: flex;
}
.identificacao-wrapper .identificacao {
  flex: 1;
  line-height: 1.8;
}
.titulo {
  font-weight: 700;
  font-size: 1.125rem;
}
.texto-registro {
    font-size: 1.5rem;
    color: var(--color-info);
    padding: 0 0.2rem;
}
.bold {
    font-weight: 700;
}
.identificacao-wrapper .identificacao span {
  font-weight: 700;
  padding-left: 0.5rem;
}
.identificacao-wrapper .identificacao .nome {
  color: var(--color-info)
}

.aviso-infos-extras {
  margin: 0;
}

.icone-chapado-alerta {
  color: var(--color-warning);
  padding-right: 16px;
}
</style>
